// extracted by mini-css-extract-plugin
module.exports = {"selectLanguageOnDark":"LanguageDropdown_selectLanguageOnDark__1FfkX"};